import {useQuery} from '@tanstack/react-query'

import {useNavigate, useParams} from 'react-router-dom'
import {toast} from 'react-toastify'
import useRequestParams from 'src/feature/bite/hook/request'
import {TerminalListSchemaResponse, TerminalSchemaResponse} from '../domain'
import {useTerminal} from '../hook'
import {API} from 'src/feature/bite/domain'
import {useAuthUser} from 'react-auth-kit'

export function useGetList() {
  const {auth, headers, errorMessage, signOut} = useRequestParams()
  const {listFilter, listFilterSet, listSet} = useTerminal()

  const userID = auth()?.id

  return useQuery(
    ['terminals', listFilter],
    async () => {
      const Response = await fetch(`${API}/Terminal/GetTerminals`, {
        method: 'POST',
        headers,
        body: JSON.stringify({
          userID,
          language: headers.Language,
          // storeId: '996225251718',
          ...listFilter,
        }),
      })

      if (Response.status === 401) {
        signOut()
      }

      const Data = await Response.json()
      const safeParse = TerminalListSchemaResponse.safeParse(Data)
      const parse = TerminalListSchemaResponse.parse(Data)

      if (parse.responseResult.result === false) {
        toast.error(parse.responseResult.exceptionDetail || 'Error', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: 'light',
        })
        return false
      }

      if (!safeParse.success) {
        throw new Error(safeParse.error.message)
      }

      listSet(parse.response)
      listFilterSet({
        ...listFilter,
        paging: {
          currentPageNumber: parse.response.paging.currentPageNumber,
          pageSize: parse.response.paging.pageSize,
        },
      })

      return true
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: false,
      cacheTime: 0,
      staleTime: 0,
      onSuccess: () => {},
      onError: (error) => {
        toast.error(errorMessage, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: 'light',
        })
      },
    }
  )
}

export function useGetDetail() {
  const {auth, headers, errorMessage, signOut} = useRequestParams()
  const {detail, detailSet} = useTerminal()
  const {terminalId} = useParams()

  const userID = auth()?.id
  const router = useNavigate()

  const currentPageNumber = detail?.detailsPaging.currentPageNumber || 1
  const pageSize = detail?.detailsPaging.pageSize || 10

  const filter = {
    filterList: [],
    orderList: [{type: 2, key: 'Date'}],
    paging: {currentPageNumber, pageSize},
    search: {value: '', keyList: []},
  }

  return useQuery(
    ['terminal', terminalId, filter],
    async () => {
      if (!terminalId) return true

      const Response = await fetch(`${API}/Terminal/GetTerminalDetails`, {
        method: 'POST',
        headers,
        body: JSON.stringify({...filter, terminalId, userID, language: headers.Language}),
      })
      if (Response.status === 401) {
        signOut()
      }

      const Data = await Response.json()
      const safeParse = TerminalSchemaResponse.safeParse(Data)
      const parse = TerminalSchemaResponse.parse(Data)

      if (parse.responseResult.result === false) {
        toast.error(parse.responseResult.exceptionDetail || 'Error', {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: 'light',
        })
        return false
      }

      if (!Data.response.terminalId) {
        router('/error/terminal')
        return
      }

      if (!safeParse.success) {
        throw new Error(safeParse.error.message)
      }

      detailSet(parse.response)

      return true
    },
    {
      enabled: true,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: false,
      retry: false,
      onSuccess: () => {},
      onError: (error) => {
        toast.error(errorMessage, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
          theme: 'light',
        })
      },
    }
  )
}
